import type { PropertyValue } from './Common';

export interface Event {
  key: string;
  value?: number;
  properties?: {
    [key: string]: PropertyValue;
  };
}
